/**
 * Registre statique d'icones SVG pour la sidebar.
 * SECURITE: Toutes les icones sont des constantes statiques definies ici.
 * Aucun contenu dynamique ou provenant du backend n'est injecte dans le HTML.
 * Object.freeze() empeche toute modification a l'execution.
 */

const SVG_OPEN = '<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">';
const SVG_CLOSE = '</svg>';

/** Construit une icone SVG complete a partir de ses donnees de trace (attribut d). */
const svgIcon = (...paths: readonly string[]): string =>
    SVG_OPEN + paths.map((d) => '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="' + d + '"/>').join('') + SVG_CLOSE;

const P1 =
    'M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 0' +
    '1-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h' +
    '-2a2 2 0 01-2-2v-2z';
const P2 = 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m3 5.197V21';
const P3 =
    'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.' +
    '29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z';
const P4 = 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z';
const P5 =
    'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 ' +
    '0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01';
const P6 = 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z';
const P7: readonly string[] = [
    'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.0' +
        '66 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 ' +
        '1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2' +
        '.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.0' +
        '65z',
    'M15 12a3 3 0 11-6 0 3 3 0 016 0z',
];
const P8 = 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z';
const P9 = 'M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z';
const P10 =
    'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a' +
    '2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z';
const P11 = 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z';
const P12 = 'M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z';
const P13 =
    'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v' +
    '3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9';
const P14 = 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4';
const P15 = 'M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z';
const P16 =
    'M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4' +
    'a2 2 0 00-2-2m-2-4h.01M17 16h.01';
const P17 = 'M4 6h16M4 12h16M4 18h7';
const P18 =
    'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4';
const P19 = 'M20 7H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zM16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2';
const P20 = 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z';
const P21 = 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z';
const P22: readonly string[] = [
    'M15 12a3 3 0 11-6 0 3 3 0 016 0z',
    'M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z',
];
const P23 = 'M3 21h18M12 3v4m0 0l-3 3m3-3l3 3M5 21V10l7-4 7 4v11';
const P24 =
    'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.6' +
    '56.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm-6 3a3 3 0 11-6 0 3 3 0 016 0zm12 0a3 ' +
    '3 0 11-6 0 3 3 0 016 0z';
const P25 =
    'M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M' +
    '21 12a9 9 0 11-18 0 9 9 0 0118 0z';
const P26 = 'M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1';

export const SIDEBAR_ICON_REGISTRY: Readonly<Record<string, string>> = Object.freeze({
    grid: svgIcon(P1),
    dashboard: svgIcon(P1),
    users: svgIcon(P2),
    utilisateurs: svgIcon(P2),
    shield: svgIcon(P3),
    lock: svgIcon(P4),
    clipboard: svgIcon(P5),
    audit: svgIcon(P5),
    clock: svgIcon(P6),
    history: svgIcon(P6),
    cog: svgIcon(...P7),
    config: svgIcon(...P7),
    envelope: svgIcon(P8),
    templates: svgIcon(P8),
    monitor: svgIcon(P9),
    sessions: svgIcon(P9),
    desktop: svgIcon(P9),
    chart: svgIcon(P10),
    analytics: svgIcon(P10),
    user: svgIcon(P11),
    profile: svgIcon(P11),
    'user-circle': svgIcon(P12),
    bell: svgIcon(P13),
    notifications: svgIcon(P13),
    settings: svgIcon(P14),
    parametres: svgIcon(P14),
    roles: svgIcon(P3),
    permissions: svgIcon(P15),
    'shield-check': svgIcon(P3),
    server: svgIcon(P16),
    mail: svgIcon(P8),
    key: svgIcon(P15),
    sliders: svgIcon(P14),
    menus: svgIcon(P17),
    building: svgIcon(P18),
    briefcase: svgIcon(P19),
    calendar: svgIcon(P20),
    document: svgIcon(P21),
    eye: svgIcon(...P22),
    gavel: svgIcon(P23),
    people: svgIcon(P24),
    help: svgIcon(P25),
    logout: svgIcon(P26),
});

export const ALLOWED_ICON_NAMES = Object.freeze(new Set(Object.keys(SIDEBAR_ICON_REGISTRY)));
export const DEFAULT_ICON = 'grid';
